import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ROUTE_PATH } from '@core/constants';
import { AuthGuard } from '@core/guards/auth.guard';

export const routes: Routes = [
  {
    path: ROUTE_PATH.LOGIN,
    loadChildren: () => import('@modules/user/login/login.module').then(m => m.LoginModule)
  },
  {
    path: '',
    redirectTo: ROUTE_PATH.LOGIN,
    pathMatch: 'full'
  },
  {
    path: '',
    loadChildren: () => import('@modules/public/public.module').then(m => m.PublicModule)
  },
  {
    path: '',
    loadChildren: () => import('@modules/user/main/main.module').then(m => m.MainModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'oauth-callback',
    loadChildren: () => import('@modules/user/oauth-callback/oauth-callback.module').then(m => m.OAuthCallbackModule)
  },
  {
    path: '**',
    loadChildren: () => import('@modules/user/not-found/not-found.module').then(m => m.NotFoundModule)
  }
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
